import { Amble, type AmbleProps } from "./Amble";

export const Postamble = (props: AmbleProps) => <Amble {...props} />;

Postamble.displayName = "Postamble";
